/** Typography classes for legal content on landing pages vs. in-app modals. */
export function getLegalStyles(variant = 'page') {
    if (variant === 'modal') {
        return {
            section: 'mb-6',
            h2: 'text-lg font-semibold text-gray-800 mt-6 mb-2 first:mt-0',
            p: 'text-gray-700 mb-3',
            ul: 'list-disc pl-6 space-y-1.5 text-gray-700 mb-3',
            li: 'text-gray-700',
            link: 'text-[#3498db] hover:underline',
            muted: 'text-gray-600 text-sm',
            disclaimer: 'text-xs text-gray-500 mt-6 pt-4 border-t border-gray-200',
        };
    }
    return {
        section: 'mb-0',
        h2: 'text-xl font-semibold text-[#00FFD0] mb-2',
        p: 'text-gray-300 mb-4 last:mb-0',
        ul: 'list-disc pl-6 space-y-2 text-gray-300 mb-4',
        li: 'text-gray-300',
        link: 'text-[#FF4DA6] hover:underline',
        muted: 'text-sm text-gray-400',
        disclaimer: 'text-xs text-gray-500',
    };
}
